import React,{useState,useEffect} from "react";
import "./AddNewProjectModal.css";
import Modal from '@mui/material/Modal';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { Select, MenuItem, Checkbox, ListItemText, FormControl, ListSubheader, Autocomplete } from '@mui/material';
import { makeStyles } from '@mui/styles';
import DatePicker, { DateObject } from "react-multi-date-picker";
import InputIcon from "react-multi-date-picker/components/input_icon";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import RadioButtons from "./RadioButtons";
import { OutlinedInput } from '@mui/material';
import TextField from "@mui/material/TextField";
import axios from "axios";
import {getProjectMasterList,getUserMaintenanceList,getProjectList} from "../function-components/Redux/ProjectMasterSlice";
import { useDispatch, useSelector } from "react-redux";

const baseURL = "https://atcilkm.listracker.accenture.com/listracker-apis";
//const baseURL = "http://localhost:1101";


export default function AddNewProjectModal(props) {
  const [open, setOpen] = useState(false);
  const [selectedMembers, setSelectedMembers] = useState([]);      
  const [requestType, setRequestType] = useState('new');
  const [name, setName] = useState('');
  const [category, setCategory] = useState('select');
  const [stakeholderName, setStakeholderName] = useState('');  
  const [requestedStartDate, setRequestedStartDate] = useState(null);  
  const [requestedEndDate, setRequestedEndDate] = useState(null);
  const [startDate, setStartDate] = useState(null);
  const [description, setDescription] = useState("");
  const [summary, setSummary] = useState("");
  const [addProjectResult, setAddProjectResult] = useState('');  
  const [selectedProject, setSelectedProject] = useState('');
  const projectData = useSelector((state) => state.projectMaster.projectMasterList);
  const projectList = useSelector((state) => state.projectMaster.projectList);
  const uniqueProjectNames = [...new Set(projectList.map((project) => project.name))];
  const [filteredProjects, setFilteredProjects] = useState(uniqueProjectNames);
  const [portalURL, setPortalURL] = useState('');  
  const [year, setYear] = useState('');
  const dispatch = useDispatch();
  const userMaintenanceList = useSelector((state) => state.projectMaster.userMaintenanceList);
  const teams = {
    Development: ['Aayushi', 'Akash', 'Ankur', 'Arpita', 'Deepak', 'Jyoti', 'Lavanya','Rajath', 'Reshmi','Shramika','Uma'],
    Design: ['Avijit','Manasa','Manoj','Medha','Vinay'],
    PowerBI: ['Akshata','Deepa']
  };
  const uniqueTeams = Array.from(new Set(userMaintenanceList.map((user) => user.team)));
  
  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setOpen(false);  
    setCategory('select');
    setName('');
    setStakeholderName('');
    setDescription('');
    setSummary('');
    setSelectedMembers([]);
    setSelectedProject('');
    setRequestedStartDate(null);
    setRequestedEndDate(null);
    setPortalURL('');
  } 
  
  
  const theme = createTheme({
    typography: {
      fontFamily: "Graphik-Regular",
    },
  });

  const useStyles = makeStyles({
    menuPaper: {
      display: 'flex',
      flexDirection: 'row',
      maxHeight: '300px !important',
      minwidth: 0,
      left: '549px !important',
      top: '170px !important'
    },
    column: {
      display: 'flex',
      flexDirection: 'column',      
    },
    header: {
      fontWeight: 'bold',
      backgroundColor: theme.palette.background.paper,
      fontSize: '16px',
      color: '#AD21FF'
    },
  });
  const classes = useStyles();

  useEffect(() => {
    dispatch(getUserMaintenanceList());
    dispatch(getProjectList());
  }, []);

  const handleChange = (event) => {
    setSelectedMembers(event.target.value);
  };

  function isDuplicateName(newName) {
    return projectData.some((project) => project.name === newName);
  }


  function handleAddProject() {    
   if (requestType === 'new' || requestType === 'change request'){
    if (name === '' || stakeholderName === '' || category === 'select' || year === '') {
      setAddProjectResult('invalidate');
      setTimeout(() => {
        setAddProjectResult('');
      }, 3000)
      return;
    }
  } else if (requestType === 'others') {
    if (description === '' || selectedMembers.length === 0 || category === 'select' || summary === '' || year === '') {
      setAddProjectResult('invalidate');
      setTimeout(() => {
        setAddProjectResult('');
      }, 3000);
      return;
    }
  }
    // if (requestType === 'new') {
    //   // Check for duplicate project name
    //   if (isDuplicateName(name)) {
    //     setAddProjectResult('duplicate');
    //     setTimeout(() => {
    //       setAddProjectResult('');
    //     }, 3000);
    //     return;
    //   }
    // }  
    axios.post(`${baseURL}/addNewProjectMasterList`,{
      "requestType": requestType,
      "name": name,
      "category": category,
      "description": description,
      "summary": summary,
      "stakeholder_name": stakeholderName,
      "assigned_to": selectedMembers,
      "status": "4",
      "total_efforts": "0",      
      "requested_date": requestedStartDate === null ? "" : requestedStartDate.format("DD/MM/YYYY"),
      "requested_enddate": requestedEndDate === null ? "" : requestedEndDate.format("DD/MM/YYYY"),
      "start_date": startDate === null ? "" : startDate.format("DD/MM/YYYY"),
      "year": year,
      "url": portalURL
    })
    .then(res => {
      console.log(res);
      setAddProjectResult(res.data.result)
      dispatch(getProjectMasterList("Portal-Wireframe"));
      props.setValue(0)
      setTimeout(() => {
        setAddProjectResult('');
      }, 3000)
      handleClose();
    })
    .catch(err => {
      setAddProjectResult("Failed to add project!")
      setTimeout(() => {
        setAddProjectResult('');
      }, 3000)
    })
   }

  function handleResetAddProject() {
    setCategory('select');
    setName('');
    setStakeholderName('');
    setDescription('');
    setSummary('');
    setSelectedMembers([]);
    setSelectedProject('');
  }
  // const filteredProjects = projectData.filter(project => ['3'].includes(project.status));
  // const uniqueProjectNames = [...new Set(filteredProjects.map((project) => project.name))];
  

  const handleProjectChange = (newValue) => {
    console.log("Selected Project Value:", newValue);
    
    const selectedProject = projectList.find((project) => project.name === newValue);
  
    console.log("Selected Project:", selectedProject);
  
    if (selectedProject) {
      setSelectedProject(selectedProject.name);
      setStakeholderName(selectedProject.stakeholder_name);
      setName(selectedProject.name);
    } else {
      setSelectedProject('');
      setStakeholderName('');
      setName('');
    }
  };
  const handleSearch = (searchTerm) => {
    const normalizedSearchTerm = searchTerm ? searchTerm.toLowerCase() : ''; // Check if searchTerm is undefined
    const filtered = uniqueProjectNames.filter((projectName) =>
      projectName.toLowerCase().includes(normalizedSearchTerm)
    );
    setFilteredProjects(filtered);
    setSelectedProject(searchTerm);
  };

  return (
    <ThemeProvider theme={theme}>
      <Typography sx={{fontWeight:"bold !important"}} onClick={handleOpen}>+ Add New Project</Typography>
      <Modal open={open} onClose={handleClose} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
        <Box className="popUp-wrapper">
          <div className="modalHeader">
              <h3 className="modalHeading">Add New Project</h3>
              <span className="close_btn_model" onClick={handleClose}>X</span>
          </div>
          <div className="radio_button_section">                
            <RadioButtons setRequestType={setRequestType}
            setCategory={setCategory}
            setName={setName}
            setStakeholderName={setStakeholderName}
            setDescription={setDescription}
            setSummary={setSummary}
            setSelectedMembers={setSelectedMembers}
            setSelectedProject={setSelectedProject}
            setRequestedStartDate={setRequestedStartDate}
            setRequestedEndDate={setRequestedStartDate}
            />
          </div>
          <div id="addProject">
            <div className={requestType === 'others' ? "inputField1-row1" : "inputField-row1"}>
              {requestType === 'others' ? 
              <FormControl variant="standard">
              <label>Category<span className="add-project--asterisk">*</span></label>
              <TextField
                variant="outlined"
                value={category}
                onChange={(e) => setCategory(e.target.value)}
                select
              >
                <MenuItem key={1} value='select'>
                  select . . .
                </MenuItem>
                <MenuItem key={2} value="R&D">
                  R & D
                </MenuItem>
                <MenuItem key={3} value="Issues">
                  Issues
                </MenuItem>                  
                <MenuItem key={4} value="Others">
                  Others
                </MenuItem>                  
              </TextField>
              </FormControl>
                :
              <FormControl variant="standard">
                <label>Category<span className="add-project--asterisk">*</span></label>
                <TextField
                  variant="outlined"
                  value={category}
                  onChange={(e) => setCategory(e.target.value)}
                  select
                >
                  <MenuItem key={1} value='select'>
                    select . . .
                  </MenuItem>
                  <MenuItem key={2} value="Wireframe">
                    Wireframe
                  </MenuItem>
                  <MenuItem key={3} value="Portal">
                    Portal
                  </MenuItem>                  
                  <MenuItem key={4} value="PowerBI">
                    PowerBI
                  </MenuItem>
                  <MenuItem key={5} value="PowerApp">
                    Power Apps
                  </MenuItem>                  
                </TextField>
              </FormControl>
               }
                <FormControl variant="standard">
                <label>Financial year<span className="add-project--asterisk">*</span></label>
                <OutlinedInput placeholder="FY24" value={year} onChange={(e) => setYear(e.target.value)}/>
              </FormControl>
              {requestType === 'new' && 
              <FormControl variant="standard">
                <label>Project name<span className="add-project--asterisk">*</span></label>
                <OutlinedInput placeholder="" value={name} onChange={(e) => setName(e.target.value)}/>
              </FormControl>} 
              {requestType === 'change request' &&
              <FormControl variant="standard">
              <label>Project name<span className="add-project--asterisk">*</span></label>
              {/* <TextField
                  variant="outlined"
                  value={selectedProject}
                  onChange={handleProjectChange}
                  select
                >
                  
               <MenuItem  value='select'>
               Select a project...
               </MenuItem>
               {uniqueProjectNames != null &&
                uniqueProjectNames != undefined &&
                uniqueProjectNames.map((projectName) => (
                 <MenuItem key ={projectName} value={projectName}>
                  {projectName}
                 </MenuItem>
                ))}
                </TextField> */}
                 <Autocomplete
                  className="selectProjectName"
                  options={uniqueProjectNames}
                  //getOptionLabel={(project) => project}
                  value={selectedProject}
                  onChange={(event, newValue) => handleProjectChange(newValue)}
                  //onChange={(event, newValue) => setSelectedProject(newValue || '')}
                  inputValue={selectedProject}
                  onInputChange={(event, newInputValue) => handleSearch(newInputValue)}
                  renderInput={(params) => <TextField {...params} label="Search projects..." />}
                  />
                </FormControl>
                  }
                   {requestType === 'others' &&
                <FormControl variant="standard" fullWidth>
                <label>Summary<span className="add-project--asterisk">*</span></label>
                <TextField className="summaryBox"
                  multiline
                  placeholder="Message....."
                  value={summary}
                  onChange={(e) => setSummary(e.target.value)} render={<InputIcon/>}
                />
              </FormControl>
                }
                {requestType === 'new' && 
                <FormControl variant="standard">
                <label>Stakeholder name<span className="add-project--asterisk">*</span></label>
                <OutlinedInput placeholder="" value={stakeholderName} onChange={(e) => setStakeholderName(e.target.value)}/>
                </FormControl> } 
                {requestType === 'change request' && 
                <FormControl variant="standard">
                <label>Stakeholder name<span className="add-project--asterisk">*</span></label>
                <OutlinedInput placeholder="" value={stakeholderName} onChange={(e) => setStakeholderName(e.target.value)}/>
                </FormControl> 
                }    
            </div>
            {requestType === 'new' && <div className="inputField-row11">                                           
              <FormControl variant="standard">
                <label>Portal URL</label>
                <OutlinedInput placeholder="" value={portalURL} onChange={(e) => setPortalURL(e.target.value)}/>
              </FormControl>                    
            </div>}
            <div className="inputField-row2">
            <div className="row2-leftContainer">
            <div className="dateRow">
              <FormControl className="dateContainer">
                <label>Requested date</label>
                <DatePicker selected={requestedStartDate}  
                onChange={(date) => setRequestedStartDate(date)} 
                render={<InputIcon/>}
                format="DD/MM/YYYY"
                />                
              </FormControl>
              <FormControl className="dateContainer">
                <label>End date</label>
                <DatePicker selected={requestedEndDate} 
                onChange={(date) => setRequestedEndDate(date)} 
                render={<InputIcon sx={{color:"red"}}/>} 
                      format="DD/MM/YYYY"
/>
              </FormControl>
            </div>
            <div className="selectRow">
            <FormControl variant="standard" fullWidth>  
            <label>Select team members</label>              
            <Select className="team_member_select"   
              multiple
              value={selectedMembers}
              onChange={handleChange}
              renderValue={(selected) => selected.join(', ')}
              MenuProps={{ classes: { paper: classes.menuPaper } }}
            >         
              {uniqueTeams
            .filter((team) =>
            userMaintenanceList.some(
              (user) => user.team === team && user.action === 'Active'
            )
            )
            .map((team) => (
            <div key={team}>
              <ListSubheader className="subheader_dropdown">{team}</ListSubheader>
              {userMaintenanceList
                .filter((user) => user.team === team && user.action === 'Active')
                .map((user) => (
                  <MenuItem key={user.id} value={user.username}>
                    <Checkbox
                      checked={selectedMembers.includes(user.username)}
                      onChange={() => {
                        const newSelectedValues = selectedMembers.includes(user.username)
                          ? selectedMembers.filter((value) => value !== user.username)
                          : [...selectedMembers, user.username];
                          setSelectedMembers(newSelectedValues);
                      }}
                    />
                    <ListItemText primary={user.username} />
                  </MenuItem>
                ))}
              </div>
                ))}
                </Select>
                </FormControl>
            </div>
            </div>
            <div className="row2-rightContainer">
            <FormControl variant="standard" fullWidth>
              <label>Description</label>
              <TextField className="descriptionBox"
                multiline
                rows={5}
                placeholder="Message....."
                value={description}
                onChange={(e) => setDescription(e.target.value)} render={<InputIcon/>}
              />
            </FormControl>
            </div>
            </div>
            <div className="buttonRow">
              <Button className="addBtn" onClick={handleAddProject}>Add</Button>
              <Button className="resetBtn" onClick={handleResetAddProject}>Reset</Button>
              {addProjectResult === 'success' && <span className="add-project--success">Project added Successfully.</span>}
              {addProjectResult === 'failed' && <span className="add-project--failed">Failed to add project!</span>}
              {addProjectResult === 'invalidate' && <span className="add-project--invalidate">All fields marked with an asterisk (*) are required.</span>} 
              {/* {addProjectResult === 'duplicate' && <span className="add-project--invalidate">Project name already exist.</span>}              */}
            </div>
          </div>
        </Box>
      </Modal>
    </ThemeProvider>
  );
}